module.exports = __webpack_public_path__ + "static/media/shameer.8c395b9f.jpg";